import { useThree } from '@react-three/fiber';
import { Vector3 } from 'three';

const t = new Vector3();

const CameraWrapper = ({ cameraPosition, target }) => {
	const { camera } = useThree();
	camera.position.set(...cameraPosition);
	camera.lookAt(t.set(...target));
	return null;
};

export default CameraWrapper;
